import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './HomePageEvents.css';

const HomePageEvents = () => {
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(`${apiUrl}/events`);
                const upcomingEvents = response.data.filter(event => event.isUpcoming === true);
                setEvents(upcomingEvents);
            } catch (err) {
                console.error('Error fetching events:', err);
            }
        };

        fetchEvents();
    }, []);

    const sortedEvents = useMemo(() => {
        return [...events].sort((a, b) => new Date(a.date) - new Date(b.date));
    }, [events]);

    const openWindow = (e, id) => {
        e.preventDefault();
        navigate(`/events/${id}`);
        window.scrollTo(0, 0);
    };

    const formatEventDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
    };

    return (
        <section className="homepage-events" id="events">
            <div className="events-inner">
                <div className="events-header" role="banner">
                    <div className="events-title-block">
                        <h2 className="events-title">Events</h2>
                        <p className="events-subtitle">Join our upcoming community events</p>
                    </div>
                </div>

                <div className={`events-grid ${sortedEvents.length === 0 ? 'empty' : ''}`}>
                    {sortedEvents.length === 0 ? (
                        <div className="event-card empty-card">
                            <div className="event-card-image-wrap">
                                <img
                                    className="event-card-image"
                                    src="https://via.placeholder.com/400x250/f5f6fa/e2e4e8?text=No+Upcoming+Events"
                                    alt="No events"
                                />
                                <span className="event-card-badge no-events">
                                    <i className="fas fa-calendar-alt" /> No Events
                                </span>
                            </div>
                            <div className="event-card-body">
                                <span className="event-card-location">
                                    <i className="fas fa-map-marker-alt" /> Zakaria Masjid, DHA Phase 8
                                </span>
                                <h3 className="event-card-title">No Upcoming Events</h3>
                            </div>
                        </div>
                    ) : (
                        sortedEvents.map((event) => (
                            <div key={event.id} className="event-card">
                                <a
                                    href={`/share/events/${event.id}`}
                                    className="event-card-link"
                                    onClick={(e) => openWindow(e, event.id)}
                                >
                                    <div className="event-card-image-wrap">
                                        <img
                                            className="event-card-image"
                                            src={event.imageUrl}
                                            alt={event.title}
                                        />
                                        <span className="event-card-badge">
                                            <i className="fas fa-calendar-alt" /> Upcoming
                                        </span>
                                    </div>
                                    <div className="event-card-body">
                                        {event.date && (
                                            <span className="event-card-date">
                                                <i className="far fa-calendar" /> {formatEventDate(event.date)}
                                            </span>
                                        )}
                                        {event.location && (
                                            <span className="event-card-location">
                                                <i className="fas fa-map-marker-alt" /> {event.location}
                                            </span>
                                        )}
                                        <h3 className="event-card-title">{event.title}</h3>
                                        <span className="event-card-cta">View details &amp; register</span>
                                    </div>
                                </a>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomePageEvents;
